import useJwt from "@src/auth/jwt/useJwt"
import axios from "axios"
import { toast } from "react-toastify"
import { responsesTypes } from "../../../views/utils/responses"

const config = useJwt.jwtConfig

//** Add to layer
export const handleAddLayerModal = (val) => (dispatch) => dispatch({ type: "ADD_LAYER_MODAL", val })

export const setSidebar = (val) => (dispatch) => dispatch({ type: "SET_SIDEBAR", val })
export const setActiveSaidbarPage = (val) => (dispatch) => dispatch({ type: "SET_ACTIVESAIDBARPAGE", val })
export const setRadarVideoEffect = (val) => (dispatch) => dispatch({ type: "SET_RADAR_VIDEO_EFFECT", val })
export const setDataByModel = (val) => (dispatch) => dispatch({ type: "SET_DATABYMODEL", val })
export const setWidget = (val) => (dispatch) => dispatch({ type: "SET_WIDGET", val })
export const setKuzatuvVideoEffect = (val) => (dispatch) => dispatch({ type: "SET_KUZATUV_VIDEO_EFFECT", val })
export const setFollowingCarOpen = (val) => (dispatch) => dispatch({ type: "SET_FOLLOWING_OPEN", val })

//** Handle GPS
export const handleGetGpsTypes = () => {
  return async (dispatch) => {
    const { data } = await axios.get(`${config.url}/foreign/gps`)
    const val = {}
    data.forEach((d) => {
      val[d.title_cr] = { ...d, [d.title_cr]: false, id: d.id }
    })
    return dispatch({ type: "SET_GPS_TYPES_CONTENT", val })
  }
}

export const handleGpsAction = (name, val, obj) => (dispatch) => {
  const a = { ...obj, [name]: { ...obj[name], id: val.id, [name]: val.cond } }
  return dispatch({ type: "SET_GPS_TYPES_CONTENT", val: a })
}

//** Handle CAMERA

export const handleCameraAction = (name, val) => (dispatch) => dispatch({ type: name.toUpperCase(), val })

// ** handle Kuzatuv
export const handleGetCameraByStat = () => {
  return async (dispatch) => {
    const { data } = await axios.get(`${config.url}/foreign/camera/service`)
    const val = {}
    data.forEach((d) => {
      val[d.name_cr] = { ...d, [d.name_cr]: false, id: d.id }
    })
    val["Сервис"] = { Сервис: false, id: 0 }
    return dispatch({ type: "SET_KAMERALAR_STATS", val })
  }
}

export const handleGetKuzatuvTypes = () => {
  return async (dispatch) => {
    const { data } = await axios.get(`${config.url}/df-datas/list/kuzatuv-kameralar`)
    const val = {}
    data.forEach((d) => {
      val[d.title] = { ...d, [d.title]: false, id: d.id }
    })
    return dispatch({ type: "SET_KUZATUV_TYPES_CONTENT", val })
  }
}

export const handleKuzatuvAction = (name, val, obj) => (dispatch) => {
  const a = { ...obj, [name]: { ...obj[name], id: val.id, [name]: val.cond } }
  return dispatch({ type: "SET_KUZATUV_TYPES_CONTENT", val: a })
}

export const handleCameraStatsAction = (name, val, obj) => (dispatch) => {
  const a = { ...obj, [name]: { ...obj[name], id: val.id, [name]: val.cond } }
  return dispatch({ type: "SET_KAMERALAR_STATS", val: a })
}
// ** handle Tadbirkor
export const handleGetTadbirkorTypes = () => {
  return async (dispatch) => {
    const { data } = await axios.get(`${config.url}/foreign/car/businesses/tadbirkor`)
    const val = {}
    data.forEach((d) => {
      val[d.name] = { ...d, [d.name]: false, id: d.inn }
    })
    return dispatch({ type: "SET_TADBIRKOR_TYPES_CONTENT", val })
  }
}

export const handleTadbirkorAction = (name, val, obj) => (dispatch) => {
  const a = { ...obj, [name]: { ...obj[name], id: val.id, [name]: val.cond } }
  return dispatch({ type: "SET_TADBIRKOR_TYPES_CONTENT", val: a })
}

// ** handle IIB
export const handleGetIIBTypes = () => {
  return async (dispatch) => {
    const { data } = await axios.get(`${config.url}/df-datas/list/iib-kameralar`)
    const val = {}
    data.forEach((d) => {
      val[d.title] = { ...d, [d.title]: false, id: d.id }
    })
    return dispatch({ type: "SET_IIB_TYPES_CONTENT", val })
  }
}

export const handleIIBAction = (name, val, obj) => (dispatch) => {
  const a = { ...obj, [name]: { ...obj[name], id: val.id, [name]: val.cond } }
  return dispatch({ type: "SET_IIB_TYPES_CONTENT", val: a })
}

// ** handle Noturar
export const handleGetNoturarTypes = () => {
  return async (dispatch) => {
    // const { data } = await axios.get(`${config.url}/foreign/xatlov/noturarlar/types`)
    // const val = {}
    // data.forEach((d) => {
    //   val[d.type] = { [d.type]: false, id: d.id }
    // })
    const { data } = await axios.get(`${config.url}/foreign/xatlov/noturar/types`)
    const val = {}
    data?.forEach((d) => {
      val[d.cr] = { [d.cr]: false, id: d.id }
    })
    return dispatch({ type: "SET_NOTURAR_TYPES_CONTENT", val })
  }
}

export const handleNoturarAction = (name, val, obj) => (dispatch) => {
  const a = { ...obj, [name]: { id: val.id, [name]: val.cond } }
  return dispatch({ type: "SET_NOTURAR_TYPES_CONTENT", val: a })
}

// ** handle OnList(Uchetdegilar)
export const handleOnList = (val) => (dispatch) => dispatch({ type: "ON_LIST", val })

// ** handle Saylov
export const handleSaylov = (val) => (dispatch) => dispatch({ type: "SAYLOV", val })

// ** handle SystemMap
export const handleEditMapHeight = (val) => (dispatch) => dispatch({ type: "SET_EDIT_HEIGHT", val })

// ** handle ALL PEOPLE
export const handleAllPeople = (val, data) => (dispatch) => dispatch({ type: "SET_ALL_PEOPLE", val, data })

// ** handle Following Cars
export const handleFollowingCars = (val) => (dispatch) => dispatch({ type: "SET_FOLLOWING_CARS", val })

export const handleSetPointsAllPeople = (val) => (dispatch) => dispatch({ type: "SET_POINTS_ALL_PEOPLE", val })

// ** handle Body Camera
export const handleBodyCamera = (val) => (dispatch) => dispatch({ type: "BODY_CAMERA", val })

// ** handle MTP
export const handleMtp = (val) => (dispatch) => dispatch({ type: "MAHALLA_MTP", val })

// ** handle Mahallar
export const handleMahallalar = (val) => (dispatch) => dispatch({ type: "MAHALLALAR", val })

export const handleMahallalarCoordinate = (val) => (dispatch) => dispatch({ type: "MAHALLA_COORDINATE", val })

export const handleMahallaDashboard = (val) => (dispatch) => dispatch({ type: "MAHALLA_DASHBOARD", val })

// ** handle Children
export const handleChildrenAction = (val) => (dispatch) => dispatch({ type: "SET_CHILDREN_TYPES_CONTENT", val })

// export const handleGetChildren = (val) => (dispatch) => dispatch({ type: "SET_CHILDREN_TYPES_CONTENT", val })

// ** handle YTX
export const handleYTX = (val) => (dispatch) => dispatch({ type: "YTX", val })

// ** handle BUS PARK
export const handleBusPark = (val) => (dispatch) => dispatch({ type: "BUS_PARK", val })

// ** handle Token axios

export const handleStopPark = (val) => (dispatch) => dispatch({ type: "TOKEN_AXIOS", val })

// ** handle handleOperativeUpdateData
export const handleOperativeUpdateData = (val) => (dispatch) => dispatch({ type: "OPERATIVE_UPDATE_DATA", val })

export const handleOperativeDeletedData = (val) => (dispatch) => dispatch({ type: "OPERATIVE_DELETED_DATA", val })

// ** handle PTZ DETECTION
export const handlePTZdetection = (val) => (dispatch) => dispatch({ type: "PTZ_DETECTION", val })

export const handlePTZdetectionHistory = (val) => (dispatch) => dispatch({ type: "PTZ_DETECTION_HISTORY", val })

// ** handle CAMERAS MENU IN AREA
export const handleSetCamerasMenuInArea = (val) => (dispatch) => dispatch({ type: "SET_CAMERA_MENU_IN_AREA", val })

export const handleSetTidsMenuInArea = (val) => (dispatch) => dispatch({ type: "SET_TIDS_MENU_IN_AREA", val })

// ** handle METALL DETECTION
export const handleMetalldetection = (val) => (dispatch) => dispatch({ type: "METALL_DETECTION", val })
export const handleMetalldetectionHistory = (val) => (dispatch) => dispatch({ type: "METALL_DETECTION_HISTORY", val })

// ** handle Jinoyatchilar
export const handleGetJinoyatchilikTypes = () => {
  return async (dispatch) => {
    const { data } = await axios.get(`${config.url}/foreign/crime`)
    const val = {}
    data.forEach((d) => {
      val[d.title_cr] = { ...d, [d.title_cr]: false, id: d.id }
    })
    return dispatch({ type: "SET_JINOYATCHILIK_TYPES_CONTENT", val })
  }
}

export const handleJinoyatchilikAction = (name, val, obj) => (dispatch) => {
  const a = { ...obj, [name]: { ...obj[name], id: val.id, [name]: val.cond } }
  return dispatch({ type: "SET_JINOYATCHILIK_TYPES_CONTENT", val: a })
}

export const handleJinoyatchilikDateAction = (year, val) => (dispatch) => {
  const a = { label: val?.label, value: val?.value, year }
  return dispatch({ type: "SET_JINOYATCHILIK_DATE", val: a })
}

export const handleRobberyDateAction = (year, val) => (dispatch) => {
  const a = { label: val?.label, value: val?.value, year }
  return dispatch({ type: "SET_ROBBERY_DATE", val: a })
}

// ** handle Operative
export const handleOperative = (name, val, obj) => (dispatch) => {
  const a = { ...obj, [name]: { ...obj[name], id: val.id, [name]: val.cond } }
  return dispatch({ type: "ADD_LAYER", val: a })
}

export const handleOperativeModal = (val) => (dispatch) => {
  return dispatch({ type: "MODAL_ACTION", val })
}

// ** handle MetallRama
export const handleMetallRama = (val) => (dispatch) => {
  return dispatch({ type: "METALLRAMA_LAYER", val })
}

// ** handle OPG modal

export const handleOpg = (name, val, obj) => (dispatch) => {
  const a = { ...obj, [name]: { ...obj[name], id: val.id, [name]: val.cond } }
  return dispatch({ type: "OPG_ADD_LAYER", val: a })
}

export const handleOpgModal = (val) => (dispatch) => {
  return dispatch({ type: "OPG_MODAL_ACTION", val })
}
export const handleOpgUpdateData = (val) => (dispatch) => dispatch({ type: "OPG_UPDATE_DATA", val })
export const handleOpgDeletedData = (val) => (dispatch) => dispatch({ type: "OPG_DELETED_DATA", val })
export const handleOpgRefreshData = (val) => (dispatch) => dispatch({ type: "OPG_REFRESH_DATA", val })

// ** handle Nearest Police
export const handleAddNearestPolice = (val) => (dispatch) => dispatch({ type: "ADD_NEAREST_POLICE", val })

// ** handle ADD CAMERA
export const handleAddCamera = (val) => (dispatch) => dispatch({ type: "ADD_CAMERA_MODAL", val })

export const handleAddedCamera = (val) => (dispatch) => dispatch({ type: "ADDED_CAMERA", val })

export const handleAddCameraREFRESH = (val) => (dispatch) => dispatch({ type: "ADD_CAMERA_REFRESH_DATA", val })

export const handleDBLclick = (val) => (dispatch) => dispatch({ type: "CAMERA_SIDEBAR_DBLCLICKED_DATA", val })

export const handleAddCamerasToSideBar = (val) => (dispatch) => dispatch({ type: "CAMERA_ADD_TO_SIDEBAR", val })

export const handleOnMapView = (val) => (dispatch) => dispatch({ type: "CAMERA_MAP_VIEW", val })

// ** handle Hydrants
export const handleGetFVVTypes = () => {
  return async (dispatch) => {
    const { data } = await axios.get(`${config.url}/foreign/fvv`)
    const val = {}
    data.forEach((d) => {
      val[d.title_cr] = { ...d, [d.title_cr]: false, id: d.id }
    })
    return dispatch({ type: "SET_FVV_TYPES_CONTENT", val })
  }
}

export const handleFVVAction = (name, val, obj) => (dispatch) => {
  const a = { ...obj, [name]: { ...obj[name], id: val.id, [name]: val.cond } }
  return dispatch({ type: "SET_FVV_TYPES_CONTENT", val: a })
}

export const handleGetShos = () => {
  return async (dispatch) => {
    const val = {
      Йўналишлар: {
        id: 1,
        title_cr: "Йўналишлар",
        Йўналишлар: false
      },
      Объектлар: {
        id: 2,
        title_cr: "Объектлар",
        Объектлар: false
      },
      Масканлари: {
        id: 3,
        title_cr: "ЙПХ Масканлари",
        масканлари: false
      }
      // ["3-халқа"]: {
      //   id: 4,
      //   title_cr: "3-халқа",
      //   ["3-халқа"]: false
      // }
    }
    return dispatch({ type: "SET_SHOS_CONTENT", val })
  }
}

export const handleSHosAction = (name, val, obj) => (dispatch) => {
  const a = { ...obj, [name]: { ...obj[name], id: val.id, [name]: val.cond } }
  return dispatch({ type: "SET_SHOS_CONTENT", val: a })
}

// ** handle for car number avto qidiruv

export const handleCarNumber1 = (val) => (dispatch) => dispatch({ type: "CAR_NUMBER", val })

// ** handle inspektorHistory
export const handleInspektorHistory = (val) => (dispatch) => dispatch({ type: "ISNPEKTOR_HISTORY", val })

//  ** handle react modal
export const handleReactModal = (val) => (dispatch) => dispatch({ type: "REACT_MODAL_ACTION", val })

//  ** handle camera sidebar
export const handleCameraSideBar = (val) => (dispatch) => dispatch({ type: "CAMERA_SIDEBAR_OPEN", val })

// ** add Route

export const handleAddRoad = (val) => (dispatch) => dispatch({ type: "ADD_ROAD_MODAL", val })
export const handleAddRoadMap = (val) => (dispatch) => dispatch({ type: "ADD_ROAD_MODAL_POINT", val })

//  ** handle camera sidebar edit info
export const handleCameraSideBarEditInfo = (val) => (dispatch) => dispatch({ type: "CAMERA_SIDEBAR_OPEN_EDIT_INFO", val })

export const handleAddCameraToSideBar = (val) => (dispatch) => dispatch({ type: "CAMERA_SIDEBAR_ADD_CAMERA", val })

export const handleAddCameraAddDone = (val) => (dispatch) => dispatch({ type: "CAMERA_ADD_DONE", val })

// ** handle Kameralar
export const handleGetKameralarTypes = () => {
  return async (dispatch) => {
    const { data } = await axios.get(`${config.url}/foreign/camera/sidebar`)
    const val = {}
    data.forEach((d) => {
      val[d.value] = { ...d, [d.value]: false, id: d.id }
    })
    dispatch({ type: "SET_KAMERALAR_TYPES_CONTENT", val })
  }
}

export const handleKameralarAction = (name, val, obj) => (dispatch) => {
  const a = { ...obj, [name]: { ...obj[name], id: val.id, [name]: val.cond } }
  return dispatch({ type: "SET_KAMERALAR_TYPES_CONTENT", val: a })
}

// ** handle Kameralar
export const handleGetLayers = () => {
  return async (dispatch) => {
    const { data } = await axios.get(`${config.url}/foreign/tadbir`)
    if (data.error) {
      toast.error(data.error)
    }
    if (data.warning) {
      toast.warning(data.warning)
    }
    if (data.message) {
      toast.success(data.message)
    }

    const val = {}
    data?.forEach((d) => {
      val[d.name] = { ...d, [d.name]: false, id: d.id, is_local: d.is_local, key: `item-${d.id}` }
    })

    return dispatch({ type: "ADD_LAYER", val })
  }
}

export const handleLayersAction = (name) => async (dispatch) => {
  const { data } = await axios.post(`${config.url}/df-datas/operational/create`, { name })
  if (data?.error) {
    toast.error(data?.error)
  }
  if (data?.message) {
    toast.success(data?.message)
    setTimeout(() => {
      dispatch(handleGetLayers())
    }, 1000)
  }
  if (data?.warning) {
    toast.warning(data?.warning)
  }
}

export const handleLayersDelete = (id) => async (dispatch, state) => {
  const { data } = await axios.delete(`${config.url}/foreign/tadbir/${id}`)
  if (data?.error) {
    toast.error(data?.error)
  }
  if (data?.message) {
    toast.success(data?.message)
    // const leftItems = _.filter(state().operative, (d) => d.id !== id)
    // const objectPrepared = {}
    // leftItems.forEach((element, index) => {
    //   element.category_name = element
    // })
    dispatch(handleOperativeDeletedData(true))
    dispatch(handleGetLayers())
    // dispatch(handleDeleteLayers(id))
    // return dispatch({ type: "ADD_LAYER", val: leftItems })
  }
  if (data?.warning) {
    toast.warning(data?.warning)
  }
}

export const handleLayersEdit = (id, name, isLocal, setIsOpenOperativeEditModal) => async (dispatch) => {
  try {
    const { data } = await axios.patch(`${config.url}/foreign/tadbir/${id}`, { name, is_local: isLocal })
    if (data?.error) {
      toast.error(data?.error)
    }
    if (data?.message) {
      toast.success(data?.message)
      setIsOpenOperativeEditModal(false)
      dispatch(handleGetLayers())
    }
    if (data?.warning) {
      toast.warning(data?.warning)
    }
  } catch (err) {
    const errMessage = err.response.data
    responsesTypes(errMessage.error, errMessage.warning, errMessage.message)
  }
}

// ** handle OPG
export const handleGetOPGLayers = () => {
  return async (dispatch) => {
    const { data } = await axios.get(`${config.url}/foreign/opg`)
    if (data.error) {
      toast.error(data.error)
    }
    if (data.warning) {
      toast.warning(data.warning)
    }
    if (data.message) {
      toast.success(data.message)
    }
    const val = {}
    data?.forEach((d) => {
      val[d.name] = { ...d, [d.name]: false, id: d.id, marker: d.marker, color: d.color }
    })
    return dispatch({ type: "OPG_ADD_LAYER", val })
  }
}

export const handleOPGLayersAction = (putData) => async (dispatch) => {
  const { data } = await axios.post(`${config.url}/foreign/opg`, putData)
  if (data?.error) {
    toast.error(data?.error)
  }
  if (data?.message) {
    toast.success(data?.message)
    setTimeout(() => {
      dispatch(handleGetOPGLayers())
    }, 1000)
  }
  if (data?.warning) {
    toast.warning(data?.warning)
  }
}

export const handleOPGLayersDelete = (id) => async (dispatch) => {
  dispatch({ type: "OPG_DELETED_DATA", val: false })
  const { data } = await axios.delete(`${config.url}/foreign/opg/${id}`)
  if (data?.error) {
    toast.error(data?.error)
  }
  if (data?.message) {
    toast.success(data?.message)
    dispatch({ type: "OPG_DELETED_DATA", val: true })
    dispatch(handleGetOPGLayers())
  }
  if (data?.warning) {
    toast.warning(data?.warning)
  }
}

export const handleOPGLayersEdit = (id, putData) => async (dispatch) => {
  dispatch({ type: "OPG_UPDATE_DATA", val: false })
  const { data } = await axios.patch(`${config.url}/foreign/opg/${id}`, putData)
  if (data?.error) {
    toast.error(data?.error)
  }
  if (data?.message) {
    toast.success(data?.message)
    dispatch({ type: "OPG_UPDATE_DATA", val: true })
    dispatch(handleGetOPGLayers())
  }
  if (data?.warning) {
    toast.warning(data?.warning)
  }
}

export const handleDeleteAreaAction = (val) => (dispatch) => dispatch({ type: "IS_DELETED_STATE", val })

export const handleAddIntervalID = (val) => (dispatch) => dispatch({ type: "ADD_INTERVAL_ID", val })

export const handleGlobalInetval = (val) => (dispatch) => dispatch({ type: "G_INTERVAL", val })
